// Generated by CoffeeScript 2.7.0
var Admin__PushesController;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import MessageNavActions from './concerns/message_nav_actions.js';

import ToggleNavMenuAction from '../toggle_nav_menu_action.js';

import FilterOptions from 'trunks/vue/admin/components/filter_options.js';

import PushPackageGenerator from 'trunks/vue/admin/compositions/push_package_generator.js';

export default Admin__PushesController = (function() {
  class Admin__PushesController extends Skylark.App.BaseController {
    index() {
      this.__toggleNavMenu();
      this._initAbortOperate();
      return this._initPushPackagePreview();
    }

    new() {
      this.__toggleNavMenu();
      this._initTypeSelect();
      this._initScheduledAtSelect();
      this._initPeriodicSelect();
      return this._initEndAtSelect();
    }

    new_by_package() {
      this.__toggleNavMenu();
      this._initStartAtSelect();
      this._initEndAtSelect();
      this._initPushPackageSelect();
      return this._initCreatePushPackage();
    }

    _initAbortOperate() {
      var table;
      table = new DomMaster(document.getElementById('uncompleted_push_agents_table'));
      if (table.isPresent()) {
        return _.each(table.findAll('.js_abort_popover'), (popover) => {
          return new Skylark.Elements.ConfirmPopover(popover, {
            confirmFunc: () => {
              var push_agent_id;
              push_agent_id = popover.closest('tr').data('push_agent_id');
              return this.__abortPushAgent(push_agent_id, function() {
                return location.reload();
              });
            }
          });
        });
      }
    }

    _initPushPackagePreview() {
      var push_list;
      push_list = new DomMaster(document.getElementById('js_push_list'));
      return _.each(push_list.findAll('.js-push_package-miniature'), (push_agent) => {
        return push_agent.node.addEventListener('click', (event) => {
          return this.__previewPushPackage(push_agent.data('id'), push_agent.data('label'));
        }, false);
      });
    }

    __abortPushAgent(push_agent_id, callback) {
      return Skylark.Libs.Ajax.get(location.pathname.replace(/pushes/, `push_agents/${push_agent_id}/abort`), {
        responseType: 'json',
        success: function() {
          newAlertify('已成功终止推送', {
            type: 'success'
          });
          return callback();
        },
        error: function() {
          return newAlertify('终止失败', {
            type: 'error'
          });
        }
      });
    }

    __previewPushPackage(push_agent_id, label) {
      return Skylark.Libs.Ajax.get(location.pathname.replace(/pushes/, `push_agents/${push_agent_id}`), {
        responseType: 'json',
        success: function(push_agent) {
          var pushes_temps;
          console.log(push_agent);
          pushes_temps = _.map(push_agent.pushes, function(push) {
            var recipient_text;
            recipient_text = _.map(push.recipient_types, function(type) {
              return '全部' + Skylark.Helpers.getZH_CN(`pushes.recipient_types.${type}`);
            }).join(', ');
            return `<tr>
  <td>${Skylark.Helpers.getZH_CN("pushes.type." + push.type)}</td>
  <td>${recipient_text}</td>
  <td>${new Date(push.scheduled_at).strftime()}</td>
  <td>${push.completed_at ? new Date(push.completed_at).strftime() : '进行中'}</td>
  <td>${push.push_count}</td>
</tr>`;
          });
          return Skylark.Elements.Modal.open(`<div class="modal-header">
  <div class="modal-title">${label}</div>
  <div class="closer js-close-modal">
    <i class="slp-times"></i>
  </div>
</div>
<table class="only-divider normal-table">
  <colgroup>
    <col width='80px' />
    <col width='120px' />
    <col width='120px' />
    <col width='120px' />
    <col width='60px' />
  </colgroup>
  <thead>
    <tr>
      <th>推送方式</th>
      <th>推送范围</th>
      <th>预约时间</th>
      <th>完成时间</th>
      <th>执行次数</th>
    </tr>
  </thead>
  <tbody>
    ${pushes_temps.join('')}
  </tbody>
</table>`, {
            modal_class_names: ['push-agent-preview-table']
          });
        }
      });
    }

    _initTypeSelect() {
      return new Skylark.Elements.DropdownSelect(DomMaster.find('.js_create_push_type_dropdown'), function(select_item) {
        return DomMaster.find('#push_agent_pushes_attributes_0_type').node.value = select_item.data('value');
      });
    }

    _initScheduledAtSelect() {
      var popover_el;
      popover_el = DomMaster.find('.js-scheduled_at-datetimepicker-popover');
      return new Skylark.Elements.DatetimePickerPopover(popover_el, {
        ensureCallback: function(date) {
          popover_el.find('.trigger .controlled-input').html(date.strftime('YYYY-MM-DD hh:mm'));
          return DomMaster.find('#push_agent_pushes_attributes_0_scheduled_at').node.value = date.strftime('YYYY-MM-DD hh:mm');
        }
      });
    }

    _initPeriodicSelect() {
      var number_input, unit_count;
      number_input = DomMaster.find('input.js_periodic_number_input').node;
      unit_count = 1;
      new Skylark.Elements.DropdownSelect(DomMaster.find('.js_periodic_unit'), (selected) => {
        unit_count = (function() {
          switch (selected.data('value')) {
            case 'day':
              return 60 * 24;
            case 'hour':
              return 60;
            default:
              return 1;
          }
        })();
        return this.__updateIntervalValue(number_input.value, unit_count);
      });
      return number_input.addEventListener('input', (event) => {
        return this.__updateIntervalValue(number_input.value, unit_count);
      }, false);
    }

    _initEndAtSelect() {
      var popover_el;
      popover_el = DomMaster.find('.js-end_at-datetimepicker-popover');
      return new Skylark.Elements.DatetimePickerPopover(popover_el, {
        ensureCallback: function(date) {
          var ref;
          if ((ref = DomMaster.find('#push_agent_aborted_at').node) != null) {
            ref.value = date.strftime('YYYY-MM-DD hh:mm');
          }
          return popover_el.find('.trigger .controlled-input').html(date.strftime('YYYY-MM-DD hh:mm'));
        }
      });
    }

    _initStartAtSelect() {
      var popover_el;
      popover_el = DomMaster.find('.js-start_at-datetimepicker-popover');
      return new Skylark.Elements.DatetimePickerPopover(popover_el, {
        ensureCallback: function(date) {
          popover_el.find('.trigger .controlled-input').html(date.strftime('YYYY-MM-DD hh:mm'));
          return DomMaster.find('#push_agent_scheduled_at').node.value = date.strftime('YYYY-MM-DD hh:mm');
        }
      });
    }

    _initPushPackageSelect() {
      if ($currentController.packages_cache == null) {
        $currentController.packages_cache = [];
      }
      if ($currentController.packages_cache.length) {
        return this.__generatePackageSelectView();
      } else {
        return Skylark.Libs.Ajax.get("/admin/push_packages", {
          responseType: 'json',
          success: (packages) => {
            $currentController.packages_cache = _.chain(packages).groupBy('push_packageable_type').map(function(value, key) {
              return {
                name: Skylark.Helpers.getZH_CN(`pushes.push_packageable_type.${key}`),
                multiple: false,
                push_packageable_type: key,
                options: _.map(value, function(option) {
                  option._selected = false;
                  return option;
                }),
                allow_clear: true
              };
            }).value();
            return this.__generatePackageSelectView();
          }
        });
      }
    }

    _initCreatePushPackage() {
      var container, form, hideGenerator;
      container = document.getElementById('js_push_package_generator_container');
      form = DomMaster.find('#new_push_agent');
      hideGenerator = function() {
        container.setAttribute('hidden', true);
        form.find('.js-push_package-select-container').show();
        return form.find('.push-form-footer').show();
      };
      return document.body.proxy('click', '.js-open-push_package-generator', (event) => {
        container.removeAttribute('hidden');
        form.find('.js-push_package-select-container').hide();
        form.find('.push-form-footer').hide();
        if (this._generator) {
          return;
        }
        this._generator = new PushPackageGenerator({
          el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('js_push_package_generator_container')
        });
        this._generator.$on('cancelClicked', function() {
          return hideGenerator();
        });
        return this._generator.$on('afterCreated', (push_package) => {
          hideGenerator();
          // clear generator cache
          this._generator = null;
          return this.__addPushPackage(push_package);
        });
      });
    }

    __generatePackageSelectView() {
      this._push_package_select_vm = new FilterOptions({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('push_package_select_container'),
        propsData: {
          groupedOptions: $currentController.packages_cache,
          multiple: false
        }
      });
      return this._push_package_select_vm.$on('valueChanged', (vm) => {
        return this.__selectPushPackage(vm.selectedOptions[0]);
      });
    }

    __addPushPackage(push_package) {
      var _push_package, package_group;
      package_group = _.findWhere($currentController.packages_cache, {
        push_packageable_type: push_package.push_packageable_type
      });
      _push_package = _.clone(push_package);
      _push_package._selected = true;
      package_group.options.unshift(_push_package);
      this.__generatePackageSelectView();
      return this.__selectPushPackage(push_package);
    }

    __updateIntervalValue(value = 0, unit_count) {
      return DomMaster.find('#push_agent_pushes_attributes_0_interval').node.value = value * unit_count;
    }

    __updatePushPackageDetails(push_package) {
      var container, detail_list;
      container = DomMaster.find('.js-push_package-info-container');
      detail_list = container.find('.js-push_package-detail-list');
      if (push_package) {
        container.addClass('has-value');
        return detail_list.html(_.chain(push_package.payload).map(function(payload, index) {
          var parsed_index, parsed_interval, parsed_recipient_types, parsed_type, parsed_waiting, ref, types;
          parsed_index = index ? '在上一次推送结束' : '';
          parsed_waiting = payload.waiting > 0 ? `${payload.waiting}分钟后` : '立即';
          parsed_type = Skylark.Helpers.getZH_CN('pushes.type.' + payload.push_type);
          parsed_recipient_types = ((ref = payload.recipient_types) != null ? ref.length : void 0) ? (types = payload.recipient_types.map(function(type) {
            return `全部${Skylark.Helpers.getZH_CN('pushes.recipient_types.' + type)}`;
          }).join(', '), `<span>(范围: </span>
<b>${types}</b>
<span> )</span>`) : '';
          parsed_interval = push_package.periodic && (index === push_package.payload.length - 1) ? '<div class="chip">周期</div>' : '';
          return `<li>
  <div class="vertical-middle">
    <span>系统将${parsed_index}</span>
    <b>${parsed_waiting}</b>
    <span>对内容进行</span>
    <b>${parsed_type}</b>
    ${parsed_recipient_types}
    ${parsed_interval}
  </div>
</li>`;
        }).join('').value());
      } else {
        return container.removeClass('has-value');
      }
    }

    __selectPushPackage(push_package) {
      var value_input;
      value_input = DomMaster.find('#push_agent_push_package_id');
      if (push_package) {
        value_input.node.value = push_package.id;
      } else {
        value_input.node.value = '';
      }
      return this.__updatePushPackageDetails(push_package);
    }

  };

  Admin__PushesController.include(MessageNavActions, ToggleNavMenuAction);

  return Admin__PushesController;

}).call(this);
